export const cilBed = ["24 24","<path d='M19.5 10.5h-9.75v5.654h-1.038v-1.922c-0.003-2.267-1.84-4.104-4.107-4.107h-2.355v-3h-1.5v16.125h1.5v-2.238l19.5 0.156v2.082h1.5v-9c-0.002-2.070-1.68-3.748-3.75-3.75h-0zM2.25 11.625h2.354c1.439 0.002 2.605 1.168 2.607 2.607v1.922h-4.962zM21.75 19.668l-19.5-0.156v-1.858h19.5zM21.75 16.154h-10.5v-4.154h8.25c1.242 0.001 2.249 1.008 2.25 2.25v0z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-bed.js
// module id = null
// module chunks = 